var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var sizeMap = {
    xsmall: 12,
    small: 14,
    medium: 16,
    large: 18,
    xlarge: 24,
};
function IconInternal(_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, children = _a.children, restProps = __rest(_a, ["size", "children"]);
    var numericSize = sizeMap[size];
    return (_jsx("svg", __assign({ width: numericSize, height: numericSize, "aria-hidden": "true" }, restProps, { children: children })));
}
export default IconInternal;
